<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<compact-layout *ngIf="layout === 'compact'"></compact-layout>
